import type { EditorPlugin } from '../../types/aha-editor';
import type AhaEditor from '../../AhaEditor';
import { Editor, Range } from 'slate';
import { isKeyHotkey } from 'is-hotkey';
import handleBackspace from './EventHandlers/Backspace';
import handleEnter from './EventHandlers/Enter';
import handleArrowDown from './EventHandlers/ArrowDown';
import handleArrowUp from './EventHandlers/ArrowUp';
import handleDelete from './EventHandlers/Delete';
import BlockUtils from '../Blocks/BlockUtils';

const onKeyDown = (
  event: KeyboardEvent,
  ahaEditor: AhaEditor
): boolean | undefined => {
  const { editor } = ahaEditor;
  const { selection } = editor;

  if (!selection || !Range.isCollapsed(selection)) return;

  const isArrowUp = isKeyHotkey('ArrowUp', event);
  const isArrowDown = isKeyHotkey('ArrowDown', event);
  const isEnter = isKeyHotkey('Enter', event);
  const isBackspace = isKeyHotkey('Backspace', event);
  const isDelete = isKeyHotkey('Delete', event);

  if (
    [isArrowUp, isArrowDown, isBackspace, isEnter, isDelete].every((v) => !v)
  ) {
    return;
  }

  const currentBlock = BlockUtils.currentBlock(editor);
  if (!currentBlock) return;

  const isVoid = Editor.isVoid(editor, currentBlock[0]);

  if (isBackspace) {
    return handleBackspace({ editor, event, currentBlock, isVoid });
  }
  if (isEnter) {
    return handleEnter({ editor, event, currentBlock, isVoid });
  }
  if (isArrowDown) {
    return handleArrowDown({ editor, event, currentBlock, isVoid });
  }
  if (isArrowUp) {
    return handleArrowUp({ editor, event, currentBlock, isVoid });
  }
  if (isDelete) {
    return handleDelete({ editor, event, currentBlock, isVoid });
  }
};

const VoidBlockKeyHandlerPlugin: EditorPlugin = {
  name: `Escape void block key handler plugin`,
  handlers: {
    onKeyDown,
  },
};

export default VoidBlockKeyHandlerPlugin;
